export default "__VITE_ASSET__BrMIydxF__"